(() => {
  const roots = document.querySelectorAll('[data-bundle-root]');
  if (!roots.length) return;

  roots.forEach((root) => {
    if (root.dataset.bundleInitialized === 'true') return;
    root.dataset.bundleInitialized = 'true';

    const configEl = root.querySelector('[data-bundle-config]');
    if (!configEl) return;

    const config = JSON.parse(configEl.textContent);
    const products = Array.isArray(config.products) ? config.products.slice() : [];
    const slotCount = Number(config.slotCount || 4);
    const defaultSize = (config.defaultSize || '').trim().toLowerCase();

    const slotsWrap = root.querySelector('[data-bundle-slots]');
    const summary = root.querySelector('[data-bundle-summary]');
    const subtotalEl = root.querySelector('[data-bundle-subtotal]');
    const discountEl = root.querySelector('[data-bundle-discount]');
    const totalEl = root.querySelector('[data-bundle-total]');
    const atcBtn = root.querySelector('[data-bundle-atc]');
    const noticeEl = root.querySelector('[data-bundle-notice]');

    const modal = root.querySelector('[data-bundle-modal]');
    const modalGrid = root.querySelector('[data-bundle-grid]');
    const searchInput = root.querySelector('[data-bundle-search]');
    const familySelect = root.querySelector('[data-bundle-family]');
    const sortSelect = root.querySelector('[data-bundle-sort]');
    const closeButtons = root.querySelectorAll('[data-bundle-close]');

    const state = {
      slots: Array.from({ length: slotCount }, () => ({
        productId: null,
        variantId: null
      })),
      activeSlot: null
    };

    function formatMoney(amount, format) {
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const match = format.match(placeholderRegex);
      const placeholder = match ? match[1] : 'amount';

      const formatWithDelimiters = (number, precision = 2, thousands = ',', decimal = '.') => {
        if (isNaN(number) || number === null) return '0';
        const fixed = Number(number).toFixed(precision);
        const parts = fixed.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return parts.join(decimal);
      };

      let formattedValue = '';
      switch (placeholder) {
        case 'amount':
          formattedValue = formatWithDelimiters(amount, 2);
          break;
        case 'amount_no_decimals':
          formattedValue = formatWithDelimiters(amount, 0);
          break;
        case 'amount_with_comma_separator':
          formattedValue = formatWithDelimiters(amount, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          formattedValue = formatWithDelimiters(amount, 0, '.', ',');
          break;
        default:
          formattedValue = formatWithDelimiters(amount, 2);
      }

      return format.replace(placeholderRegex, formattedValue);
    }

    function money(cents) {
      const value = Number(cents || 0) / 100;
      return formatMoney(value, config.moneyFormat || '${{amount}}');
    }

    function escapeHtml(str) {
      return String(str || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function normalizeFamily(value) {
      if (!value) return '';
      if (Array.isArray(value)) return value.map((item) => normalizeFamily(item)).filter(Boolean).join(', ');
      if (typeof value === 'object') {
        return String(value.label || value.name || value.title || '').trim();
      }
      return String(value).trim();
    }

    function getProduct(productId) {
      return products.find((product) => Number(product.id) === Number(productId)) || null;
    }

    function getSizeOptionIndex(product) {
      if (!Array.isArray(product?.options)) return -1;
      return product.options.findIndex((optionName) => String(optionName).trim().toLowerCase() === 'size');
    }

    function getVariantForSize(product, sizeValue) {
      if (!product) return null;

      const sizeOptionIndex = getSizeOptionIndex(product);

      if (sizeOptionIndex < 0) {
        return product.variants.find((variant) => variant.available) || product.variants[0] || null;
      }

      const exactMatch = product.variants.find((variant) => {
        const optionValue = variant.options?.[sizeOptionIndex];
        return String(optionValue || '').trim().toLowerCase() === String(sizeValue || '').trim().toLowerCase();
      });

      if (exactMatch && exactMatch.available) return exactMatch;

      return product.variants.find((variant) => variant.available) || product.variants[0] || null;
    }

    function getSlotData(slotIndex) {
      const slot = state.slots[slotIndex];
      if (!slot.productId) return { slot, product: null, variant: null };

      const product = getProduct(slot.productId);
      const variant = product?.variants?.find((item) => Number(item.id) === Number(slot.variantId)) || null;
      return { slot, product, variant };
    }

    function buildFamilyOptions() {
      if (!familySelect) return;

      const families = [...new Set(
        products
          .map((product) => normalizeFamily(product.scentFamily))
          .filter(Boolean)
      )].sort((a, b) => a.localeCompare(b));

      familySelect.innerHTML = `
        <option value="">All scent families</option>
        ${families.map((family) => `<option value="${escapeHtml(family)}">${escapeHtml(family)}</option>`).join('')}
      `;
    }

    function renderSlots() {
      if (!slotsWrap) return;

      slotsWrap.innerHTML = state.slots.map((slotState, index) => {
        const label = `${config.labels.slotPrefix || 'Candle'} ${index + 1}`;
        const { product, variant } = getSlotData(index);
        const isFilled = Boolean(product);

        if (!isFilled) {
          const imageMarkup = config.placeholderImage
  ? `<img class="ff-bundle-builder__slot-image" src="${config.placeholderImage}" alt="${escapeHtml(label)}" loading="lazy">`
  : `<div class="ff-bundle-builder__slot-fallback">${escapeHtml(label)}</div>`;

          return `
            <div class="ff-bundle-builder__slot" data-slot-index="${index}">
              <div class="ff-bundle-builder__slot-media-wrap">
                ${imageMarkup}
              </div>
              <h3 class="ff-bundle-builder__slot-title">${escapeHtml(label)}</h3>
              <p class="ff-bundle-builder__slot-notes">&nbsp;</p>
              <div class="ff-bundle-builder__actions">
                <button type="button" class="button button--secondary" data-slot-select="${index}">
                  ${escapeHtml(config.labels.select || 'Select')}
                </button>
              </div>
            </div>
          `;
        }

        const sizeOptionIndex = getSizeOptionIndex(product);

        const pills = product.variants.map((item) => {
          const sizeLabel = sizeOptionIndex > -1 ? item.options?.[sizeOptionIndex] : item.title;
          const pressed = Number(item.id) === Number(variant?.id);

          return `
            <button
              type="button"
              class="ff-bundle-builder__pill ${item.available ? '' : 'is-disabled'}"
              data-slot-size="${index}"
              data-variant-id="${item.id}"
              ${item.available ? '' : 'disabled'}
              aria-pressed="${pressed ? 'true' : 'false'}"
            >
              ${escapeHtml(sizeLabel)}
            </button>
          `;
        }).join('');

        return `
          <div class="ff-bundle-builder__slot" data-slot-index="${index}">
            <div class="ff-bundle-builder__slot-media-wrap">
              ${
                product.featuredImage
  ? `<div class="ff-bundle-builder__modal-card-media"><img class="ff-bundle-builder__modal-card-image" src="${product.featuredImage}" alt="${escapeHtml(product.featuredAlt || product.title)}" loading="lazy"></div>`
  : `<div class="ff-bundle-builder__slot-fallback">${escapeHtml(product.title)}</div>`
              }
            </div>
            <h3 class="ff-bundle-builder__slot-title">${escapeHtml(product.title)}</h3>
            <p class="ff-bundle-builder__slot-notes">${escapeHtml(product.scentNotes || '')}</p>
            <div class="ff-bundle-builder__pills">${pills}</div>
            <p class="ff-bundle-builder__slot-price">${money(variant?.price || 0)}</p>
            <div class="ff-bundle-builder__actions">
              <button type="button" class="button button--secondary" data-slot-select="${index}">
                ${escapeHtml(config.labels.swap || 'Swap')}
              </button>
              <button type="button" class="ff-bundle-builder__link-button" data-slot-remove="${index}">
                ${escapeHtml(config.labels.remove || 'Remove')}
              </button>
            </div>
          </div>
        `;
      }).join('');
    }

    function renderSummary() {
      const allFilled = state.slots.every((slot) => slot.variantId);

      if (!allFilled) {
        summary.hidden = true;
        subtotalEl.textContent = '';
        if (discountEl) discountEl.textContent = '';
        totalEl.textContent = '';
        atcBtn.disabled = true;
        return;
      }

      const selectedVariants = state.slots
        .map((slot, index) => getSlotData(index).variant)
        .filter(Boolean);

      const subtotal = selectedVariants.reduce((sum, variant) => sum + Number(variant.price || 0), 0);
      const discount = Math.min(...selectedVariants.map((variant) => Number(variant.price || 0)));
      const estimatedTotal = subtotal - discount;

      subtotalEl.textContent = money(subtotal);
      if (discountEl) discountEl.textContent = `-${money(discount)}`;
      totalEl.textContent = money(estimatedTotal);

      summary.hidden = false;
      atcBtn.disabled = false;
    }

    function sortProducts(items, sortValue) {
      const next = items.slice();

      if (sortValue === 'newest') {
        next.sort((a, b) => Number(b.publishedAt || 0) - Number(a.publishedAt || 0));
        return next;
      }

      if (sortValue === 'best-selling') {
        next.sort((a, b) => Number(a.sourceIndex || 0) - Number(b.sourceIndex || 0));
        return next;
      }

      next.sort((a, b) => String(a.title || '').localeCompare(String(b.title || '')));
      return next;
    }

    function getFilteredProducts() {
      const term = String(searchInput?.value || '').trim().toLowerCase();
      const family = String(familySelect?.value || '').trim();
      const sortValue = String(sortSelect?.value || 'alphabetical');

      let filtered = products.filter((product) => product.available);

      if (family) {
        filtered = filtered.filter((product) => normalizeFamily(product.scentFamily) === family);
      }

      if (term) {
        filtered = filtered.filter((product) => {
          const haystack = `${product.title || ''} ${product.scentNotes || ''}`.toLowerCase();
          return haystack.includes(term);
        });
      }

      return sortProducts(filtered, sortValue);
    }

    function renderModalGrid() {
      if (!modalGrid) return;

      const selectedProductId = state.activeSlot !== null ? state.slots[state.activeSlot].productId : null;
      const filtered = getFilteredProducts();

      if (!filtered.length) {
        modalGrid.innerHTML = `<p>No candles match your filters.</p>`;
        return;
      }

      modalGrid.innerHTML = filtered.map((product) => {
        const selectedClass = Number(selectedProductId) === Number(product.id) ? 'is-selected' : '';

        return `
          <button
            type="button"
            class="ff-bundle-builder__modal-card ${selectedClass}"
            data-modal-product="${product.id}"
          >
            ${
              product.featuredImage
  ? `<img class="ff-bundle-builder__slot-image" src="${product.featuredImage}" alt="${escapeHtml(product.featuredAlt || product.title)}" loading="lazy">`
  : `<div class="ff-bundle-builder__slot-fallback">${escapeHtml(product.title)}</div>`
            }
            <h4>${escapeHtml(product.title)}</h4>
            <p>${escapeHtml(product.scentNotes || '')}</p>
          </button>
        `;
      }).join('');
    }

    function openModal(slotIndex) {
      state.activeSlot = slotIndex;
      renderModalGrid();
      modal.hidden = false;
      document.body.classList.add('overflow-hidden');
    }

    function closeModal() {
      modal.hidden = true;
      state.activeSlot = null;
      document.body.classList.remove('overflow-hidden');
    }

    function setSlotProduct(slotIndex, productId) {
      const product = getProduct(productId);
      if (!product) return;

      const preferredVariant = getVariantForSize(product, defaultSize);
      if (!preferredVariant) return;

      state.slots[slotIndex] = {
        productId: product.id,
        variantId: preferredVariant.id
      };

      renderSlots();
      renderSummary();
      closeModal();
    }

    function setSlotVariant(slotIndex, variantId) {
      const current = state.slots[slotIndex];
      const product = getProduct(current.productId);
      if (!product) return;

      const variant = product.variants.find((item) => Number(item.id) === Number(variantId));
      if (!variant || !variant.available) return;

      state.slots[slotIndex].variantId = variant.id;

      renderSlots();
      renderSummary();
    }

    function removeSlot(slotIndex) {
      state.slots[slotIndex] = {
        productId: null,
        variantId: null
      };

      renderSlots();
      renderSummary();
    }

async function addBundleToCart() {
  const items = state.slots
    .filter((slot) => slot.variantId)
    .map((slot) => ({
      id: Number(slot.variantId),
      quantity: 1
    }));

  if (items.length !== slotCount) return;

  atcBtn.disabled = true;
  noticeEl.textContent = '';

  try {
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items })
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.description || 'Unable to add bundle to cart.');
    }

    noticeEl.textContent = config.labels.added || 'Bundle added to cart';

    await refreshCartDrawer();
  } catch (error) {
    noticeEl.textContent = error.message || 'Something went wrong.';
  } finally {
    atcBtn.disabled = false;
  }
}

async function refreshCartDrawer() {
  const response = await fetch(`${window.Shopify.routes.root}cart?sections=cart-drawer,cart-icon-bubble`);
  const sections = await response.json();
  const parser = new DOMParser();

  if (sections['cart-drawer']) {
    const html = parser.parseFromString(sections['cart-drawer'], 'text/html');
    const newDrawer = html.querySelector('cart-drawer');
    const currentDrawer = document.querySelector('cart-drawer');

    if (newDrawer && currentDrawer) {
      currentDrawer.replaceWith(newDrawer);
    }
  }

  if (sections['cart-icon-bubble']) {
    const html = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
    const newBubble = html.querySelector('#shopify-section-cart-icon-bubble');
    const currentBubble = document.querySelector('#shopify-section-cart-icon-bubble');

    if (newBubble && currentBubble) {
      currentBubble.innerHTML = newBubble.innerHTML;
    }
  }

  const refreshedDrawer = document.querySelector('cart-drawer');

  if (refreshedDrawer && typeof refreshedDrawer.open === 'function') {
    refreshedDrawer.open();
  }
}

    root.addEventListener('click', (event) => {
      const selectBtn = event.target.closest('[data-slot-select]');
      if (selectBtn) {
        openModal(Number(selectBtn.dataset.slotSelect));
        return;
      }

      const removeBtn = event.target.closest('[data-slot-remove]');
      if (removeBtn) {
        removeSlot(Number(removeBtn.dataset.slotRemove));
        return;
      }

      const sizeBtn = event.target.closest('[data-slot-size]');
      if (sizeBtn) {
        setSlotVariant(Number(sizeBtn.dataset.slotSize), Number(sizeBtn.dataset.variantId));
        return;
      }

      const modalProduct = event.target.closest('[data-modal-product]');
      if (modalProduct && state.activeSlot !== null) {
        setSlotProduct(state.activeSlot, Number(modalProduct.dataset.modalProduct));
      }
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', closeModal);
    });

    if (searchInput) searchInput.addEventListener('input', renderModalGrid);
    if (familySelect) familySelect.addEventListener('change', renderModalGrid);
    if (sortSelect) sortSelect.addEventListener('change', renderModalGrid);
    if (atcBtn) atcBtn.addEventListener('click', addBundleToCart);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) {
        closeModal();
      }
    });

    buildFamilyOptions();
    renderSlots();
    renderSummary();
  });
})();